import { RefObject, useEffect, useState } from 'react';

import { scrolledTopOrBottom } from 'Utilities/newyu';

/**
 * This hook returns whether the scroll bar is fully scrolled to the bottom, to the top, or is touching both (when no scroll is visible).
 * @param ref The reference to DOM node
 */
const useScrolledTopOrBottom = (ref: RefObject<HTMLElement>): ScrolledTopOrBottom => {
  const [scrollState, setScrollState] = useState({ top: true, bottom: false });

  useEffect(() => {
    const elem = ref.current;

    if (!elem) {
      return;
    }

    const handleScrollState = () => {
      if (elem) {
        setScrollState(scrolledTopOrBottom(elem));
      }
    };

    handleScrollState();

    elem.addEventListener('scroll', handleScrollState);
    window.addEventListener('resize', handleScrollState);

    return () => {
      elem.removeEventListener('scroll', handleScrollState);
      window.removeEventListener('resize', handleScrollState);
    };
  }, [ref]);

  return scrollState;
};

export default useScrolledTopOrBottom;
